import React, {memo} from 'react'
import {Timeline, Space, Tooltip} from 'antd'
import {
    ArrowRightOutlined,
    InfoOutlined
} from '@ant-design/icons'
import {
    TimeLineContentWrapper,
    TimeLineContentHeaderWrapper,
} from '../../../styles/styles'
import {ActivityStage} from "../../../types/types";
import {Avatar} from "../../../../../../ui/Avatar";
import DotIcon from "../../../lib/components/dot-icon/diot-icon";
import Stage from "./stage/stage";
import TimelineItemHeader from "../activity-timeline-item-header/activity-timeline-item-header";
import {TimelineItemProps} from "../activity-timeline-Item";


type ActivityTimelineStageType = Omit<TimelineItemProps, 'data'>

interface ActivityTimelineStageProps extends ActivityTimelineStageType {
    className?: string;
    data?: ActivityStage
}


const ActivityTimelineStage: React.FC<ActivityTimelineStageProps> = memo((props: ActivityTimelineStageProps) => {
    const {date, user, data} = props;
    return (
            <TimeLineContentWrapper>
                <TimeLineContentHeaderWrapper>
                    <TimelineItemHeader date={date} title={'Стадия изменена'}/>
                    <Space>
                        <Space>
                            <Avatar src={user?.icon} alt={user?.name}/>
                            <Tooltip placement="top" title="Автор"><span>{user?.name}</span></Tooltip>
                        </Space>
                    </Space>
                </TimeLineContentHeaderWrapper>
                <Space>
                    <Stage style={data?.stage_from?.style}>
                        {data?.stage_from?.name}
                    </Stage>
                    <ArrowRightOutlined style={{color: '#b1bac3'}}/>
                    <Stage style={data?.stage_to?.style}>
                        {data?.stage_to?.name}
                    </Stage>
                </Space>
            </TimeLineContentWrapper>
    )
})

export default ActivityTimelineStage;
